import { Breadcrumbs } from "components/breadcrumbs";
import { useOne, useParse, useUpdate } from "@refinedev/core";
import { FullScreenLoading } from "components/fullScreenLoading";
import { IBlogDetail, IBlogForm } from "interfaces";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { BlogForm } from "./components";

export const EditBlog: React.FC = () => {
  const parse = useParse();
  const { params } = parse();
  const { mutate, isLoading: isUpdatingBlog } = useUpdate();
  const navigate = useNavigate();

  const {
    data,
    isFetching,
    isPreviousData,
    isLoading,
  } = useOne<IBlogDetail>({
    resource: "mkt/blogs",
    id: params?.id,
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!params?.id,
    } as any,
  });


	const onSubmit = (values: IBlogForm) => {
    const submitValues = { ...values };
		const id = params?.id;
		if (id) {
			mutate(
				{
					resource: "mkt/blogs",
					id: id,
					meta: {
						ignoreResourceWrapper: true,
					},
					values: {
						...submitValues,
					},
				},
				{
					onSuccess: () => {
						toast.success("Edit successfully");
						navigate(`/mkt/blog/${id}`);
					},
				}
			);	
		}
  };

  const blogDetailData = data?.data ?? null;

  if (isLoading) {
    return <FullScreenLoading />;
  }

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Edit Blog" />
      {blogDetailData ? (
        <BlogForm
          defaultData={blogDetailData}
          id={params?.id}
					onSubmit={onSubmit}
        />
      ) : (
        <></>
      )}
      {((isFetching && isPreviousData) || isUpdatingBlog) ? <FullScreenLoading /> : <></>}
    </div>
  );
};
